import { Grid2, Paper, IconButton } from "@mui/material";
import CustomTable from "./CustomTable";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { formatCurrency } from "../utils/helper";

const RelationshipRevenueTable = ({ tableData, dialogLabel, setShowTable }) => {
  console.log('tableData:', tableData);
  const boldCategories = ["Total Income", "Asset NII", "Liability NII", "Fee Income"];
  const columns = [
    {
      name: "",
      id: "category",
      element: (row) => boldCategories.includes(row.category) ? <b>{row.category}</b> : row.category
    },
    {
      name: "FY25", 
      id: "FY25",
      element: (row) => boldCategories.includes(row.category) ? <b>{row.FY25}</b> : row.FY25
    },
    {
      name: "FY24",
      id: "FY24",
      element: (row) => boldCategories.includes(row.category) ? <b>{row.FY24}</b> : row.FY24
    },
    {
      name: "FY23",
      id: "FY23", 
      element: (row) => boldCategories.includes(row.category) ? <b>{row.FY23}</b> : row.FY23
    },
  ];

  const categories = [
    { label: "Total Income", field: "total_income" },
    { label: "Asset NII", field: "asset_nii" },
    { label: "Asset NII Target", field: "asset_nii_target" },
    { label: "Asset NII Target Achieved", field: "percentage_asset_nii_target_achieved" },
    { label: "Liability NII", field: "liabilities_nii" },
    { label: "Liability NII Target", field: "liabilities_nii_target" },
    { label: "Liability NII Target Achieved", field: "percentage_liabilities_nii_target_achieved" },
    { label: "Fee Income", field: "fee_income" },
    { label: "Fee Income Target", field: "fee_income_target" },
    { label: "Fee Income Target Achieved", field: "percentage_fee_income_target_achieved" }
  ];

  const mappedData = categories.map(({ label, field }) => ({
    category: label,
    FY25: tableData?.[2025]?.[field] 
      ? field.includes('percentage') 
        ? `${tableData[2025][field].toFixed(1)}%`
        : formatCurrency(tableData[2025][field])
      : "...",
    FY24: tableData?.[2024]?.[field]
      ? field.includes('percentage')
        ? `${tableData[2024][field].toFixed(1)}%`
        : formatCurrency(tableData[2024][field])
      : "...",
    FY23: tableData?.[2023]?.[field]
      ? field.includes('percentage')
        ? `${tableData[2023][field].toFixed(1)}%`
        : formatCurrency(tableData[2023][field])
      : "..."
  }));

  const handleTableView = () => {
    setShowTable(false);
  };

  return (
    <div className="my-4">
      <Grid2 display={"grid"} rowGap={2}>
        <div className='flex flex-start items-center h-[1rem]'>
        <IconButton aria-label="<>" onClick={handleTableView}>
          <ArrowBackIcon sx={{ fontSize: 16 }}/>
        </IconButton>
        <div className="flex justify-center font-bold text-md charts-data-container">
          {dialogLabel}
        </div>
        </div>
        <CustomTable
          columns={columns}
          data={mappedData}
          count={categories.length}
          hidePagination
        />
      </Grid2>
    </div>
  );
};

export default RelationshipRevenueTable;
